<template>
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    stroke="currentColor"
    stroke-width="1.5"
    viewBox="0 0 24 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="20" width="22" x="1" y="1"></rect>
    <line x1="1" x2="23" y1="5.5" y2="5.5"></line>
    <line x1="12" x2="12" y1="8.5" y2="18.5"></line>
    <line x1="7" x2="17" y1="13.5" y2="13.5"></line>
  </svg>
</template>
